'use client';
import React from 'react';
import PropTypes from 'prop-types';
var Tab = function Tab() {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
Tab.displayName = 'Tab';
Tab.propTypes = {
  disabled: PropTypes.bool,
  eventKey: PropTypes.string,
  title: PropTypes.node,
  children: PropTypes.node,
  icon: PropTypes.node
};
export default Tab;